/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReferenceMaterial } from '../../models/reference-material';

export interface ReferenceMaterialControllerIndex$Params {
  id: string;
}

export function referenceMaterialControllerIndex(http: HttpClient, rootUrl: string, params: ReferenceMaterialControllerIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<ReferenceMaterial>> {
  const rb = new RequestBuilder(rootUrl, referenceMaterialControllerIndex.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReferenceMaterial>;
    })
  );
}

referenceMaterialControllerIndex.PATH = '/reference-material/{id}/index';
